import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Typography,
  Box,
} from "@mui/material";

export default function RemoveProductPickingModal({ open, onClose, onConfirm }) {

  const product = {
    sku: "GLUC2001",
    producto: "Glucosoral Durazno 24x15.3 Fl Oz",
    bin: "A-42",
    onHand: 50,
    cantidad: 10,
    imageUrl: "https://mayaland-src.s3.us-east-2.amazonaws.com/GLUC2001.jpg"
  };

  const handleConfirm = () => {
    // Remove picked up product
    onConfirm()
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Remove product</DialogTitle>
      <DialogContent>
        {product && (
          <Grid container spacing={2}>
            {product.imageUrl && (
              <Grid item xs={12} md={4} size={4}>
                <Box
                  component="img"
                  src={product.imageUrl}
                  alt={product.producto}
                  sx={{
                    width: "100%",
                    height: "auto",
                    borderRadius: 2,
                    objectFit: "contain",
                    maxHeight: 200,
                    mb: 2,
                  }}
                />
              </Grid>
            )}

            <Grid item xs={12} md={8} size={8}>
              <Grid container spacing={1}>
                <Grid item size={12}>
                    <Typography variant="h5">
                      {product.producto}
                    </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={handleConfirm}
          color="error"
        >
          Remove
        </Button>
      </DialogActions>
    </Dialog>
  );
}